import React, { useMemo } from 'react'
import Link from 'next/link'
import { getUser } from 'src/libs/browser'
import { getInfo, hasRequiredItem } from 'src/libs/util'
import { URL_TEMPLATE } from 'src/libs/constant'
import useGetWithContext from 'src/hooks/useGetWithContext'
import userApi from 'src/api/userApi'

export function TextLinkUserName ({ userName, userId, href, newTab }) {
  const user = getUser()
  const { userRoles } = user
  const { data: userDetail } = useGetWithContext(
    `GET_USER_DETAIL_BY_ID${user.userId}`,
    userApi.detail,
    user.userId,
    { isDisabled: !user.userId }
  )
  const { classType } = getInfo(userDetail?.userInfoData)
  const permissions = useMemo(() => {
    return {
      canViewStudentDetail: hasRequiredItem(userRoles, ['admin',
        'manager',
        'manager-monitor',
        'employee-ministry',
        'employee-monitor',
        'manager-teacher',
        'employee-sale',
        'manager-sale',
        'employee-collaborator-class',
        'employee-collaborator-class',
        'employee-customer-care',
        'employee-customer-care-specialist'
      ]) ||
      classType?.some(item => ['BACKUP', 'REGULAR'].includes(item))
    }
  }, [user])

  if (permissions.canViewStudentDetail === true && userId) {
    return <Link href={`${URL_TEMPLATE.STUDENT_DETAIL}?id=${userId}`}>{newTab ? <a target='_blank' className='text-link color-main'> {userName} </a> : <a className='text-link'> {userName} </a>}</Link>
  }
  return userName
}
